"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenshareIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("./withSVGIcon");
var Icon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#7EFED7' : _b;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("path", { d: "M23 18V18C24.1046 18 25 17.1046 25 16V4C25 2.89543 24.1046 2 23 2H3C1.89543 2 1 2.89543 1 4V16C1 17.1046 1.89543 18 3 18V18", stroke: "black", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M11.991 13.593C12.5631 13.0729 13.4369 13.0729 14.009 13.593L20.7928 19.7601C21.4691 20.3749 21.0341 21.5 20.1201 21.5H5.87991C4.96588 21.5 4.53091 20.3749 5.20724 19.7601L11.991 13.593Z", fill: fill, stroke: "black", id: "path-1" }, void 0)] }, void 0));
};
exports.ScreenshareIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 26 24' });
//# sourceMappingURL=ScreenshareIcon.js.map